import { loader } from '@/components/Loader.js';
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import {ModalContainerWarningLmc} from "../Modal/ModalWarningLmc";
import {ModalContainerValidate} from "../Modal/ModalValidate";
import {ModalContainerCheckRows} from "../Modal/ModalCheckRows";
import {ModalContainerNotLMC} from "../Modal/ModalNotLMC";
function getLoadsheetStatusClass(statusID) {
  switch (statusID) {
    case "0": //"Проект"
      return "bg-orange";
    case "1": //"Подтверждён"
    case "2": //"Подписан"
      return "bg-green";
    case "3": //"Отклонён"
      return "bg-decline";
    default:
      return "bg-primary";
  }
}
export var LoadsheetLmcPage = {
  controller: function () {
    this.topMenu = [
      {title:'Задачи', url: '', icon: 'fa-tasks'},
      {title:'Профиль', url: '/profile', icon: 'fa-user'},
      { title: "Выйти", url: "/logout", icon: "fa-sign-out" },
    ]

    this.paxsList = ['y','w','c']

    this.isExpand = {
    }

    this.itemsWithoutPlaces = [
      'Mail', 'Cargo', 'Equipment'
    ]

    this.data = {
      pax: {
        y: {adl: {weight: 0, count: 0}, chd: {weight: 0, count: 0}, inf:{weight: 0, count: 0}},
        w: {adl: {weight: 0, count: 0}, chd: {weight: 0, count: 0}, inf:{weight: 0, count: 0}},
        c: {adl: {weight: 0, count: 0}, chd: {weight: 0, count: 0}, inf:{weight: 0, count: 0}},
      },
      items: [
        {
          title: 'Bag',
          cpt: 0,
          cpts: [
            {label: 'Cpt 0', count: 0, weight: 0,places: 0},
            {label: 'Cpt 1', count: 1, weight: 0,places: 0},
            {label: 'Cpt 2', count: 2, weight: 0,places: 0},
            {label: 'Cpt 3', count: 3, weight: 0,places: 0},
            {label: 'Cpt 4', count: 4, weight: 0,places: 0},
            {label: 'Cpt 5', count: 5, weight: 0,places: 0},
          ]
        },
        {
          title: 'Mail',
          cpt: 0,
          cpts: [
            {label: 'Cpt 0', count: 0, weight: 0,places: 0},
            {label: 'Cpt 1', count: 1, weight: 0,places: 0},
            {label: 'Cpt 2', count: 2, weight: 0,places: 0},
            {label: 'Cpt 3', count: 3, weight: 0,places: 0},
            {label: 'Cpt 4', count: 4, weight: 0,places: 0},
            {label: 'Cpt 5', count: 5, weight: 0,places: 0},
          ]
        },
        {
          title: 'Cargo',
          cpt: 0,
          cpts: [
            {label: 'Cpt 0', count: 0, weight: 0,places: 0},
            {label: 'Cpt 1', count: 1, weight: 0,places: 0},
            {label: 'Cpt 2', count: 2, weight: 0,places: 0},
            {label: 'Cpt 3', count: 3, weight: 0,places: 0},
            {label: 'Cpt 4', count: 4, weight: 0,places: 0},
            {label: 'Cpt 5', count: 5, weight: 0,places: 0},
          ]
        },
        {
          title: 'Equipment',
          cpt: 0,
          cpts: [
            {label: 'Cpt 0', count: 0, weight: 0,places: 0},
            {label: 'Cpt 1', count: 1, weight: 0,places: 0},
            {label: 'Cpt 2', count: 2, weight: 0,places: 0},
            {label: 'Cpt 3', count: 3, weight: 0,places: 0},
            {label: 'Cpt 4', count: 4, weight: 0,places: 0},
            {label: 'Cpt 5', count: 5, weight: 0,places: 0},
          ]
        },
      ]
    }

    this.dictionary = {
      pax: {
        y: {
          adl: {
            min: 0,
            max: 12,
            coefficient: 40
          },
          chd: {
            min: 2,
            max: 8,
            coefficient: 67
          },
          inf: {
            min: 0,
            max: 5,
            coefficient: 73
          },
        },
        w: {
          adl: {
            min: 0,
            max: 12,
            coefficient: 40
          },
          chd: {
            min: 2,
            max: 8,
            coefficient: 67
          },
          inf: {
            min: 0,
            max: 5,
            coefficient: 73
          },
        },
        c: {
          adl: {
            min: 0,
            max: 12,
            coefficient: 40
          },
          chd: {
            min: 2,
            max: 8,
            coefficient: 67
          },
          inf: {
            min: 0,
            max: 5,
            coefficient: 73
          },
        },
      },
      items: [
          {
            cpts: [
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
            ]
          },
          {
            cpts: [
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
            ]
          },
          {
            cpts: [
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
            ]
          },
          {
            cpts: [
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
            ]
          },
          {
            cpts: [
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
            ]
          },
          {
            cpts: [
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
              {maxPlaces:30, minPlaces: 0},
            ]
          },
        ]
    }
    //тут начальный объект
    this.initData = JSON.parse(JSON.stringify(this.data))
    this.setData = (obj) => {
      this.data = obj
    }
    this.updatePax = (id,key,isAdd = true) => {
      this.data.pax[id][key].count = isAdd ? this.data.pax[id][key].count + 1 : this.data.pax[id][key].count - 1
      this.data.pax[id][key].weight = this.data.pax[id][key].count * this.dictionary.pax[id][key].coefficient
      this.calculateLmc()
    }
    this.clearHandler = () => {
      this.data = {
        pax: {
          y: {adl: {weight: 0, count: 0}, chd: {weight: 0, count: 0}, inf:{weight: 0, count: 0}},
          w: {adl: {weight: 0, count: 0}, chd: {weight: 0, count: 0}, inf:{weight: 0, count: 0}},
          c: {adl: {weight: 0, count: 0}, chd: {weight: 0, count: 0}, inf:{weight: 0, count: 0}},
        },
        items: [
          {
            title: 'Bag',
            cpt: 0,
            cpts: [
              {label: 'Cpt 0', count: 0, weight: 0,places: 0},
              {label: 'Cpt 1', count: 1, weight: 0,places: 0},
              {label: 'Cpt 2', count: 2, weight: 0,places: 0},
              {label: 'Cpt 3', count: 3, weight: 0,places: 0},
              {label: 'Cpt 4', count: 4, weight: 0,places: 0},
              {label: 'Cpt 5', count: 5, weight: 0,places: 0},
            ]
          },
          {
            title: 'Mail',
            cpt: 0,
            cpts: [
              {label: 'Cpt 0', count: 0, weight: 0,places: 0},
              {label: 'Cpt 1', count: 1, weight: 0,places: 0},
              {label: 'Cpt 2', count: 2, weight: 0,places: 0},
              {label: 'Cpt 3', count: 3, weight: 0,places: 0},
              {label: 'Cpt 4', count: 4, weight: 0,places: 0},
              {label: 'Cpt 5', count: 5, weight: 0,places: 0},
            ]
          },
          {
            title: 'Cargo',
            cpt: 0,
            cpts: [
              {label: 'Cpt 0', count: 0, weight: 0,places: 0},
              {label: 'Cpt 1', count: 1, weight: 0,places: 0},
              {label: 'Cpt 2', count: 2, weight: 0,places: 0},
              {label: 'Cpt 3', count: 3, weight: 0,places: 0},
              {label: 'Cpt 4', count: 4, weight: 0,places: 0},
              {label: 'Cpt 5', count: 5, weight: 0,places: 0},
            ]
          },
          {
            title: 'Equipment',
            cpt: 0,
            cpts: [
              {label: 'Cpt 0', count: 0, weight: 0,places: 0},
              {label: 'Cpt 1', count: 1, weight: 0,places: 0},
              {label: 'Cpt 2', count: 2, weight: 0,places: 0},
              {label: 'Cpt 3', count: 3, weight: 0,places: 0},
              {label: 'Cpt 4', count: 4, weight: 0,places: 0},
              {label: 'Cpt 5', count: 5, weight: 0,places: 0},
            ]
          },
        ]
      }

      this.calculateLmc()
    }
    this.saveInStorage = () => {
      const taskId = m.route.param('taskId')
      const data = localStorage.getItem('lmc')
      let obj = {}
      if (data) {
        obj = JSON.parse(data)
      }
      obj[taskId] = this.data
      localStorage.setItem('lmc', JSON.stringify(obj))
    }
    this.deleteInStorage = () => {
      const taskId = m.route.param('taskId')
      const data = localStorage.getItem('lmc')
      let obj = {}
      if (data) {
        obj = JSON.parse(data)
        delete obj[taskId]
      }
      localStorage.setItem('lmc', JSON.stringify(obj))
    }
    this.getValueFromStorage = () => {
      const obj = JSON.parse(localStorage.getItem('lmc'))
      const taskId = m.route.param('taskId')
      if (obj && obj[taskId]) {
        this.data = obj[taskId]
      }
    }
    this.getValueFromStorage()


    this.changeValue = 0
    this.maxLmc = 0
    this.calculateLmc = (isInit) => {
      this.changeValue = 0
      Object.entries(this.data.pax).forEach(([key, val]) => {
        Object.entries(val).forEach(([paxType, paxValue]) => {
          if (this.initData.pax[key][paxType].weight !== paxValue.weight) {
            this.changeValue += Math.abs(this.initData.pax[key][paxType].weight - paxValue.weight)
          }
        })
      })
      this.data.items.forEach((e, id) => {
        e.cpts.forEach((cpt, cptId) => {
          if (this.initData.items[id].cpts[cptId].weight
            !== this.data.items[id].cpts[cptId].weight) {
            if(this.itemsWithoutPlaces.includes(e.title)) {
              const changeWeight = Math.abs(this.initData.items[id].cpts[cptId].weight - this.data.items[id].cpts[cptId].weight)
              this.changeValue += Math.abs(changeWeight)
            } else {
              const changeWeight = Math.abs(this.initData.items[id].cpts[cptId].weight - this.data.items[id].cpts[cptId].weight)
              const changePlaces = Math.abs(this.initData.items[id].cpts[cptId].places - this.data.items[id].cpts[cptId].places)
              this.changeValue += Math.abs(changeWeight)
            }
          }
        })
      })

      if (this.changeValue > this.maxLmc && !isInit) {
        ModalContainerWarningLmc.init()
        ModalContainerWarningLmc.open()
        return true
      }
    }
    this.calculateLmc(true)

    loader.show()
    m.request({
      method: "GET",
      url:`/api/task/${m.route.param('taskId')}/getLimitLMC`
    }).then(
      (res) => {
        if (res.limitLMC && typeof res.limitLMC.status === "number") {
          ModalContainerNotLMC.init()
          ModalContainerNotLMC.open()
          return
        }
        this.maxLmc = res.limitLMC || 0
      }
    )
    this.loadsheet = {}
    m.request({
      method: "GET",
      url:`/api/task/${m.route.param('taskId')}/getLoadSheet`
    }).then(
      (res) => {
        this.loadsheet = res.loadsheet || {}
        loader.hide()
      }
    )

    //словарь
    m.request({
      method: "GET",
      url:`/api/task/${m.route.param('taskId')}/getWeightNorm`
    }).then(
      (res) => {
        if (res) {
          this.dictionary = res
        }
      }
    )
    this.maxItemsLMC = 0
    m.request({
      method: "GET",
      url:`/api/task/${m.route.param('taskId')}/getMaxItemsLMC`
    }).then(
      (res) => {
        this.maxItemsLMC = res.maxItemsLMC || 0
      }
    )
    this.activeCpts = []
    m.request({
      method: "GET",
      url:`/api/task/${m.route.param('taskId')}/getLMC`
    }).then(
      (res) => {
        this.activeCpts = res.cpts
        if (res.lmc.pax){
          Object.entries(res.lmc.pax).forEach(([key,val]) => {
            Object.entries(val).forEach(([typeKey, value]) => {
              this.data.pax[key][typeKey] = value
            })
          })
        }
        if (res.lmc.items) {
          res.lmc.items.forEach(e => {
            const index = this.data.items.findIndex(item => item.title === e.title)
            if (index === -1) return
            this.data.items[index].cpt = e.cpt
            const i = this.data.items[index].cpts.findIndex(cpt => cpt.label === e.cpts.label)
            if (i === -1) return
            this.data.items[index].cpts[i] = e.cpts
          })
        }
      }
    )
     this.validateFields = () => {
      let isEdit = false
      this.data.items.forEach(e => {
        e.cpts.forEach(cpt => {
          if (cpt.weight !== 0 || cpt.places !== 0) {
            isEdit = true
          }
        })
      })
       if (isEdit) return isEdit
       Object.values(this.data.pax).forEach((val) => {
         Object.values(val).forEach(value => {
           if (value.weight !== 0 || value.count !== 0) {
             isEdit = true
           }
         })
       })
       return isEdit
    }
    this.checkNumberRows = () => {
      let count = 0

      this.data.items.forEach(e => {
        e.cpts.forEach(element => {
          if (element.weight !== 0 || element.places !== 0) {
            count += 1
          }
        })
      })
      Object.values(this.data.pax).forEach((val) => {
        Object.values(val).forEach(value => {
          if (value.weight !== 0 || value.count !== 0) {
            count += 1
          }
        })
      })
      return this.maxItemsLMC >= count
    }

  },

  view: function (ctrl) {
    return [
      m.component(HeaderMenuBlock, {
        menu: ctrl.topMenu
      }),
      m(".loadsheet-header", [
        m("i.fa.fa-2x.fa-arrow-left.arrow-icon", {
          onclick: function () {
            history.back();
          },
        }),
        m(".loadsheet-title", [
          m(".loadsheet-name", "Loadsheet/LMC"),
          m(".loadsheet-text", ctrl.loadsheet.title),
        ]),
        m(
          ".loadsheet-status",
          {
            class: getLoadsheetStatusClass(0),
          },
          ctrl.loadsheet.state_name
        ),
      ]),
      m('div.bg-light', [
        m("div[style='padding: 8px 16px;']", `LMC: ${ctrl.changeValue}/MAX ${ctrl.maxLmc} KG`)
      ]),
      m("div.bg-light", [
          m("div.bg-white[style='padding: 12px 16px;']", [
            m("div[style=font-size: 18px]", 'PAX'),
            ctrl.paxsList.map(e =>
              m("div", [
              m("div[style='margin: 12px 0 0']", [
                m("div.bg-turquoise.border-turquoise[style='border:1px solid';border-radius: 4px;display:flex;justify-content:space-between;align-items:center;padding:12px 15px]", [
                  m(`div[style=font-size:18px;color:white;]`, `PAX ${e.toUpperCase()}`),
                  m(`i.fa.fa-1.5x.fa-chevron-down[style='font-size:18px;color:white;cursor:pointer; ${ctrl.isExpand[e] ? 'transform:rotate(180deg)' : ''}']`, {
                    onclick: function () {
                      ctrl.isExpand[e] = !ctrl.isExpand[e]
                    },
                  }),
                ]),

                m(`div[style='${ctrl.isExpand[e] ? 'display:block': 'display:none'}']`,

                  m("div[style='display:flex; justify-content: space-between; align-items:center; gap:8px; margin-top: 8px']", [
                    m("div[style='width:50%']", [
                      m("div.label-field", 'ADL'),
                      m('div',m("div[style='border:1px solid #cccccc; border-radius: 5px; padding: 1px; display:flex; justify-content: space-between; align-items:center']", [
                          m("i.fa.fa-minus.minus-btn", {
                            onclick: function () {
                              if (ctrl.dictionary.pax[e].adl.min < ctrl.data.pax[e].adl.count) {
                                ctrl.updatePax(e,'adl', false)
                              }
                            },
                          }),
                          m("div[style='user-select: none']", ctrl.data.pax[e].adl.count),
                          m("i.fa.fa-plus.plus-btn", {
                            onclick: function () {
                              if (ctrl.dictionary.pax[e].adl.max > ctrl.data.pax[e].adl.count) {
                                ctrl.updatePax(e,'adl')
                              }
                            },
                          }),
                        ]),
                      )
                    ]),
                    m("div[style='width:50%']", [
                      m("div.label-field", 'Weight'),
                      m("input.form-control[style='height: 42px']", {
                        value: `${ctrl.data.pax[e].adl.weight} KG`,
                        disabled:true
                      })
                    ])
                  ]),

                  m("div[style='display:flex; justify-content: space-between; align-items:center; gap:8px; margin-top: 8px']", [
                    m("div[style='width:50%']", [
                      m("div.label-field", 'CHD'),
                      m('div',m("div[style='border:1px solid #cccccc; border-radius: 5px; padding: 1px; display:flex; justify-content: space-between; align-items:center']", [
                          m("i.fa.fa-minus.minus-btn", {
                            onclick: function () {
                              if (ctrl.dictionary.pax[e].chd.min < ctrl.data.pax[e].chd.count) {
                                ctrl.updatePax(e,'chd', false)
                              }
                            },
                          }),
                          m("div[style='user-select: none']", ctrl.data.pax[e].chd.count),
                          m("i.fa.fa-plus.plus-btn", {
                            onclick: function () {
                              if (ctrl.dictionary.pax[e].chd.max > ctrl.data.pax[e].chd.count) {
                                ctrl.updatePax(e,'chd')
                              }
                            },
                          }),
                        ]),
                      )
                    ]),
                    m("div[style='width:50%']", [
                      m("div.label-field", 'Weight'),
                      m("input.form-control[style='height: 42px']", {
                        value: `${ctrl.data.pax[e].chd.weight} KG`,
                        disabled:true
                      })
                    ])
                  ]),

                  m("div[style='display:flex; justify-content: space-between; align-items:center; gap:8px; margin-top: 8px']", [
                    m("div[style='width:50%']", [
                      m("div.label-field", 'INF'),
                      m('div',m("div[style='border:1px solid #cccccc; border-radius: 5px; padding: 1px; display:flex; justify-content: space-between; align-items:center']", [
                          m("i.fa.fa-minus.minus-btn", {
                            onclick: function () {
                              if (ctrl.dictionary.pax[e].inf.min < ctrl.data.pax[e].inf.count) {
                                ctrl.updatePax(e,'inf', false)
                              }
                            },
                          }),
                          m("div[style='user-select: none']", ctrl.data.pax[e].inf.count),
                          m("i.fa.fa-plus.plus-btn", {
                            onclick: function () {
                              if (ctrl.dictionary.pax[e].inf.max > ctrl.data.pax[e].inf.count) {
                                ctrl.updatePax(e,'inf')
                              }
                            },
                          }),
                        ]),
                      )
                    ]),
                    m("div[style='width:50%']", [
                      m("div.label-field", 'Weight'),
                      m("input.form-control[style='height: 42px']", {
                        value: `${ctrl.data.pax[e].inf.weight} KG`,
                        disabled:true
                      })
                    ])
                  ])
                ),
              ]),
            ]))
          ]),

        ctrl.data.items.map((e, id) => (
          m("div.bg-white[style='padding: 12px 16px;margin-top: 16px']", [
            m("div.bg-turquoise.border-turquoise[style='border:1px solid';border-radius: 4px;display:flex;justify-content:space-between;align-items:center;padding:12px 15px]", [
              m(`div[style=font-size:18px;color:white;]`, e.title),
              m(`i.fa.fa-1.5x.fa-chevron-down[style='font-size:18px;color:white;cursor:pointer; ${ctrl.isExpand[e.title] ? 'transform:rotate(180deg)' : ''}']`, {
                onclick: function () {
                  ctrl.isExpand[e.title] = !ctrl.isExpand[e.title]
                },
              }),
            ]),
            m(`div[style='${ctrl.isExpand[e.title] ? 'display:block': 'display:none'}']`, [
              // m("div[style=font-size: 18px]", e.title),
              m("div", [
                m("div[style=display:flex;justify-content:space-between;align-items:center; margin-top:16px; gap:16px]", [
                  m("div[style='display:flex;justify-content:center;align-items:center;flex-direction:column']", [
                    m("div.label-field", 'Cpt'),
                    m("div[style='display:flex;justify-content:center;align-items:center;background-color:#EEEEEE; border-radius:4px; height: 52px; width:39px; font-size: 30px']", e.cpt)
                  ]),
                  ctrl.itemsWithoutPlaces.includes(e.title) ? '' : m("div[style='flex: 1 1 auto']", [
                    m("div.label-field", 'Places'),
                    m('div',m("div[style='border:1px solid #cccccc; border-radius: 5px; padding: 6px; display:flex; justify-content: space-between; align-items:center;min-height: 52px']", [
                        m("i.fa.fa-minus.minus-btn", {
                          onclick: function () {
                            if (ctrl.dictionary.items[id].cpts.minPlaces < ctrl.data.items[id].cpts[e.cpt].places) {
                              ctrl.data.items[id].cpts[e.cpt].places -= 1
                            }
                            if (ctrl.data.items[id].cpts[e.cpt].places === 0) {
                              ctrl.data.items[id].cpts[e.cpt].weight = 0
                            }
                            ctrl.calculateLmc()

                          },
                        }),
                        m("div[style='user-select: none']",ctrl.data.items[id].cpts[e.cpt].places),
                        m("i.fa.fa-plus.plus-btn", {
                          onclick: function () {
                            if (ctrl.dictionary.items[id].cpts.maxPlaces > ctrl.data.items[id].cpts[e.cpt].places) {
                              ctrl.data.items[id].cpts[e.cpt].places += 1
                            }
                            if (ctrl.data.items[id].cpts[e.cpt].places === 0) {
                              ctrl.data.items[id].cpts[e.cpt].weight = 0
                            }
                            ctrl.calculateLmc()
                          },
                        }),
                      ]),
                    )
                  ]),
                  m(`div[style='min-width:100px; ${ctrl.itemsWithoutPlaces.includes(e.title) ? "flex: 1 1 auto" :""}']`, [
                    m("div.label-field", 'Weight'),
                    m("input.form-control[style='height: 52px']", {
                      value: `${ctrl.data.items[id].cpts[e.cpt].weight}`,
                      oninput: function (event) {
                        ctrl.data.items[id].cpts[e.cpt].weight = event.target.value
                        ctrl.calculateLmc()
                      },
                      onclick: function () {
                        if (ctrl.data.items[id].cpts[e.cpt].weight === 0) {
                          ctrl.data.items[id].cpts[e.cpt].weight = ''
                        }
                      }
                    })
                  ]),
                ]),
                m("div[style='display:flex; justify-content:space-between;flex-wrap:wrap; margin-top:6px;']",[e.cpts.map((cpt, index ) => (
                    m(`div.cpt-plane[style=' ${!ctrl.activeCpts.includes(index) ? 'display: none;' : ''} width: 32.5%; margin-top:10px']`, {
                      class: e.cpt === index && 'cpt-plane-active',
                      onclick: function () {
                        ctrl.data.items[id].cpt = index
                      }
                    },[
                      m("div[style='font-weight:700; font-size:21px;line-height:24.15px']",cpt.label),
                      cpt.weight > 0 && m("div",`${cpt.weight} KG`)
                    ])
                  ))]
                )
              ])
            ])
          ])
        )),

        m("div.bg-white[style='padding: 22px 16px;margin-top: 16px']", [
          m("button.btn.bg-red-darken.btn-lg[style='width:100%;font-size:18px;color:#fff']", {
            onclick: function () {
              ctrl.clearHandler()
            }
          }, 'Очистить поля'),
          m("button.btn.bg-turquoise.btn-lg[style='width:100%;font-size:18px;color:#fff;margin-top:12px']", {
            onclick: function () {

              ctrl.saveInStorage()
              loader.show()
              setTimeout(() => {
                loader.hide()
              }, 100)
            }
          }, 'Сохранить изменения'),
          m("button.btn.bg-confirm.btn-lg[style='width:100%;font-size:18px;color:#fff;margin-top:12px']", {
            onclick: function () {
              const isEdit = ctrl.validateFields()
              if (!isEdit) {
                ModalContainerValidate.init()
                ModalContainerValidate.open()
                return
              }
              if (typeof ctrl.maxItemsLMC !== 'object') {
                const isExceeded = ctrl.checkNumberRows()
                if (!isExceeded) {
                  ModalContainerCheckRows.init()
                  ModalContainerCheckRows.open()
                  return
                }
              }

              if (ctrl.calculateLmc()) {
                return;
              }
              m.request({
                method: "PUT",
                url:`/api/task/${m.route.param('taskId')}/setLoadSheet`,
                data:{
                  idLS: ctrl.loadsheet.idLS,
                  idState:1 ,
                  lmc: ctrl.data
                }
              }).then(res => {
                ctrl.deleteInStorage()
                m.route(`/task/${m.route.param('taskId')}/loadsheet`)
              })
            }
          }, 'Подтвердить с LMC')
        ])
      ])
    ]
  }
}
